export default "__VITE_ASSET__DIjTTi0d__"